import type { Component } from 'vue';

import { MessageComponentKey } from '@/types/components';
import { ChatMessage } from '@/types/socket';

// 메세지 컴포넌트 결정(날짜, 입출, 더보기 등)
export default function getMessageComponent(
  message: ChatMessage,
  messageMap: Record<MessageComponentKey, Component>
): Component {
  let componentKey: MessageComponentKey | '' = '';

  if (['in', 'out'].includes(message.inout)) {
    componentKey = 'TRAFFIC';
  } else if (message.more) {
    componentKey = 'MORE';
  } else if (message.isOwn) {
    componentKey = 'CHAT_GOING';
  } else if (message.flag === 'date') {
    componentKey = 'DATE';
  } else if (message.flag === 'status') {
    componentKey = 'STATUS';
  } else if (['tr', 'mt'].includes(message.flag)) {
    componentKey = 'CHAT_COMING';
  }

  return messageMap[componentKey];
}
